<template>
  <div>
    <v-row>
      <v-col cols="12" sm="8" md="9">
        <px-circular-loading v-if="loading"/>
        <template v-if="!loading">
          <v-list-item v-for="produto in produtos" :key="produto.id">
            <v-list-item-avatar class="square-avatar">
              <px-oferta-foto height="40"
                              width="40"
                              :foto="produto.oferta.foto"/>
            </v-list-item-avatar>
            <v-list-item-content>
              {{ produto.tituloProduto }}
              <div>
                <px-show-variacoes-completo :variacoes="produto.variacoes"/>
              </div>
              <div>
                <px-especificacao-oferta text-class="caption"
                                         :especificacao="produto.especificacaoProduto"/>
              </div>
            </v-list-item-content>
            <v-list-item-content>
              {{ produto.quantidade }} {{ produto.unidadeMedida.descricao }} x
              {{ produto.precoUnitario | currency }}
            </v-list-item-content>
            <v-list-item-content>
              {{ produto.total | currency }}
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <v-btn depressed block
               class="rounded-tag-small"
               link :to="`/marketplace/vendas/${compra.id}`">
          Ver venda
        </v-btn>
        <v-btn depressed block
               class="mt-3 rounded-tag-small"
               link :to="`/marketplace/vendas/${compra.id}`">
          Enviar mensagem
        </v-btn>
        <px-compra-cancelar-dialog btn-class="mt-3 rounded-tag-small"
                                   v-if="!hideCancelado"
                                   :compra="compra"
                                   :small="false"
                                   block
                                   @movimentar="onMovimentar"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SituacaoCompraMarketplace } from 'px-business-components';
import CompraService from './compras-service';
import CompraCancelarDialog from './detalhes/CompraCancelarDialog.vue';

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      loading: false,
      produtos: [],
    };
  },
  computed: {
    hideCancelado() {
      return this.compra.situacao === SituacaoCompraMarketplace.keys.CANCELADA.key
        || this.compra.situacao === SituacaoCompraMarketplace.keys.RECUSADA.key;
    },
  },
  methods: {
    getProdutosCompra() {
      this.loading = true;
      CompraService.getProdutosCompra(this.compra.id)
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onMovimentar() {
      this.$emit('change');
    },
  },
  created() {
    this.getProdutosCompra();
  },
  components: {
    pxCompraCancelarDialog: CompraCancelarDialog,
  },
};
</script>
